// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"451":"312fd4ee","822":"599991d0","959":"dcc5f712"}[chunkId] + ".js";
};